import { render, staticRenderFns } from "./EventConnections.vue?vue&type=template&id=147e818f"
import script from "./EventConnections.js?vue&type=script&lang=js&external"
export * from "./EventConnections.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports